import React from "react"
import "./src/assets/styles/styles.css"
import Layout from "./src/components/Layout"
import "bootstrap/dist/js/bootstrap.min.js"
import "@popperjs/core/dist/umd/popper.min.js"

export function wrapPageElement({ element, props }) {
  return <Layout {...props}>{element}</Layout>
}

// GA4 SPA pageview tracking
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "page_view", {
      page_path: location.pathname,
      page_location: location.href,
      page_title: document.title,
    })
  }
}
